









import { Component, Prop, Vue } from "vue-property-decorator";
import Handle from "@/components/controls/Handle.vue";

@Component({
  components: { Handle },
})
export default class DropUp extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  private visible = false;

  private get style() {
    return {
      visibility: this.visible ? "visible" : "hidden",
      "pointer-events": this.visible ? "auto" : "none",
    };
  }
}
